'use strict';

var filter = require('./filter.js');
var stepper = require('./stepper.js');
var text = require('./text.js');
var heading = require('./heading.js');
var avatar = require('./avatar.js');
var headerNavBar = require('./headerNavBar.js');
var headerNavSubItem = require('./headerNavSubItem.js');
var headerNavItem = require('./headerNavItem.js');
var headerNavIcon = require('./headerNavIcon.js');
var drawer = require('./drawer.js');
var _switch = require('./switch.js');
var tooltip = require('./tooltip.js');
var coloredCard = require('./coloredCard.js');
var toast = require('./toast.js');
var banner = require('./banner.js');
var dateInput = require('./dateInput.js');
var calendarMonth = require('./calendarMonth.js');
var grid = require('./grid.js');
var divider = require('./divider.js');
var modal = require('./modal.js');
var tree = require('./tree.js');
var cellTextSub = require('./cellTextSub.js');
var card = require('./card.js');
var highlightedIcon = require('./highlightedIcon.js');
var radio = require('./radio.js');
var select = require('./select.js');
var dropdown = require('./dropdown.js');
var overlay = require('./overlay.js');
var anchor = require('./anchor.js');
var badge = require('./badge.js');
var breadcrumbs = require('./breadcrumbs.js');
var button = require('./button.js');
var chip = require('./chip.js');
var control = require('./control.js');
var fileInput = require('./fileInput.js');
var icon = require('./icon.js');
var formLabel = require('./formLabel.js');
var tabs = require('./tabs.js');
var tag = require('./tag.js');
var typo = require('./typo.js');

const designTokens = (theme) => ({
    ...anchor.anchorTokens(theme),
    ...badge.badgeTokens(theme),
    ...breadcrumbs.breadcrumbsTokens(theme),
    ...button.buttonTokens(theme),
    ...card.cardTokens(theme),
    ...cellTextSub.cellTextSubTokens(theme),
    ...chip.chipTokens(theme),
    ...control.controlTokens(theme),
    ...divider.dividerTokens(theme),
    ...dropdown.dropdownTokens(theme),
    ...fileInput.fileInputTokens(theme),
    ...formLabel.formLabelTokens(theme),
    ...grid.gridTokens(theme),
    ...icon.iconTokens(theme),
    ...highlightedIcon.highlightedIconTokens(theme),
    ...modal.modalTokens(theme),
    ...overlay.overlayTokens(theme),
    ...radio.radioTokens(theme),
    ...select.selectTokens(theme),
    ...tabs.tabsTokens(theme),
    ...tag.tagTokens(theme),
    ...tree.treeTokens(theme),
    ...typo.typoTokens(theme),
    ...calendarMonth.calendarMonthTokens(theme),
    ...dateInput.dateInputTokens(theme),
    ...banner.bannerTokens(theme),
    ...toast.toastTokens(theme),
    ...coloredCard.coloredCardTokens(theme),
    ...tooltip.tooltipTokens(theme),
    ..._switch.switchTokens(theme),
    ...headerNavIcon.headerNavIconTokens(theme),
    ...headerNavItem.headerNavItemTokens(theme),
    ...headerNavSubItem.headerNavSubItemTokens(theme),
    ...drawer.drawerTokens(theme),
    ...headerNavBar.headerNavBarTokens(theme),
    ...avatar.avatarTokens(theme),
    ...heading.headingTokens(theme),
    ...text.textTokens(theme),
    ...stepper.stepperTokens(theme),
    ...filter.filterTokens(theme),
});

exports.designTokens = designTokens;
//# sourceMappingURL=index.js.map
